export function formatTravelPeriod(travelPeriod) {
  const travelPeriodFrom = new Date(travelPeriod.from)
  const travelPeriodTo = new Date(travelPeriod.to)

  const yearFrom = travelPeriodFrom.getFullYear()
  const yearTo = travelPeriodTo.getFullYear()

  const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric', year: yearFrom !== yearTo ? 'numeric' : undefined }

  const formattedTravelPeriodFrom = travelPeriodFrom.toLocaleDateString('en-US', options)
  const formattedTravelPeriodTo = travelPeriodTo.toLocaleDateString('en-US', options)

  return `${formattedTravelPeriodFrom} - ${formattedTravelPeriodTo}`
}
